import { useState, useCallback } from "react";
import db from "state/db";
import api from "state/axios";

const useProductCache = () => {
    const [loading, setLoading] = useState(false);
    const [lastCached, setLastCached] = useState(null);
    const [error, setError] = useState(null);

    const refreshCache = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const res = await api.get("/products/active");
            const products = res.data.map((p) => ({ ...p, _id: p._id.toString() }));
            await db.products.clear();
            await db.products.bulkPut(products);
            setLastCached(new Date());
        } catch (err) {
            setError(err.message);
            throw err;
        } finally {
            setLoading(false);
        }
    }, []);

    const getProducts = useCallback(() => db.products.toArray(), []);

    const getCachedCount = useCallback(() => db.products.count(), []);

    return { refreshCache, getProducts, getCachedCount, loading, lastCached, error };
};

export default useProductCache;
